import { useAtomValue } from 'jotai';

import { Fields } from '~/components/pages/Reception/InvitationModal/SendInvitationPanel/types';
import { invitationModalState } from '~/state/reception/atoms';

export const useDefaultValues = () => {
  const { phoneNumber, memo } = useAtomValue(invitationModalState);

  const defaultValues: Fields = {
    phoneNumber: phoneNumber,
    memo: memo,
  };

  return defaultValues;
};
